module.exports = __webpack_public_path__ + "static/media/error.8ec2f988.png";